<div mat-dialog-title>
    Creating PO
</div>
<div mat-dialog-content>
    <div class="row">
        <div class="col-9">
            <mat-form-field class="w-100 item-data">
                <mat-label>Item</mat-label>
                <input type="text" matInput readonly [value]="getItemName(item)" class="font-weight-medium">
                <item-type-chip matSuffix [item]="convertItemForChip(item)" class="mr-2"></item-type-chip> 
            </mat-form-field>
        </div>
        <div class="col-3">
            <mat-form-field class="w-100">
                <mat-label>Quantity to Assign</mat-label>
                <input type="number" matInput step="0" [(ngModel)]="qty" [min]="1" [max]="getUnassignedQty(item)">
                <span matSuffix>/{{getUnassignedQty(item)}}</span>
            </mat-form-field>
        </div>
        <div class="col-12 mb-2" *ngIf="item.purchasingSheetItem?.materialBid">
            <mat-checkbox [(ngModel)]="useExistingQuote">Use Existing Quote</mat-checkbox>
        </div>
        <div class="col-12" *ngIf="!useExistingQuote">
          <filtered-vendor-list
            [typeId]="getTypeId()"
            [typeName]="getTypeName()"
            [customer]="item.workOrder?.order?.customer"
            [editable]="true" [(vendor)]="vendor"></filtered-vendor-list>
        </div>
        <div class="col-12" *ngIf="useExistingQuote">
            <div class="w-100 d-flex flex-column border rounded p-2" *ngLet="item.purchasingSheetItem.materialBid as selectedQuote">
              <div class="mb-2 font-weight-bold">
                Existing Quote
              </div>
            <div class="w-100 d-flex mt-auto">

            <div>
              <div>
                From <b>{{ selectedQuote.vendor?.name ?? 'Unknown Vendor' }}</b>
              </div>
                <div>
                  Value: <b>{{((selectedQuote.perItemBid || (selectedQuote.totalBid/selectedQuote.qty)) | currency) || '--'}}</b>
                </div>
              <div class="lead-time">
                Lead time: <b>{{selectedQuote.leadTimeDays}}</b> days
              </div>
            </div>
            </div>
          </div>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" class="button-text" [disabled]="!isValid" [matDialogClose]="output">Create PO</button>
    <button mat-stroked-button class="button-text" [matDialogClose]="false">Cancel</button>
</div>